// @flow

import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { localize } from "redux-i18n";
import actionCreators from "@modules/service/actionCreator";
import type {
  DynamicQuestionContent,
  LengthScopeDetails,
} from "@modules/service/reducer/dynamic-questions/types";
import * as serviceSelectors from "@modules/service/selectors";
import { SchemaForm } from "@components";
import { split } from "@transformers/schema";
import type { StepProps } from "@components";
import { View } from "@components";

type PropsFromState = $Exact<{
  draft: ?DynamicQuestionContent,
  schema: ?Object,
  isValid: boolean,
}>;

type PropsFromDispatch = $Exact<{
  onUpdateDraft: typeof actionCreators.UpdateDynamicQuestionDraft,
}>;

type Props = $Exact<{
  ...StepProps,
  ...PropsFromLocalize,
  ...PropsFromState,
  ...PropsFromDispatch,
}>;

export class Step4LengthScope extends React.Component<Props> {
  lengthScopeSchema = split(this.props.schema, ["durationDays", "dayType"]);

  componentDidMount() {
    if (this.props.onChange) {
      this.props.onChange(this.props.draft || {}, this.props.isValid);
    }
  }

  handleChanges = (formData: Object) => {
    if (formData) {
      const updatedDraft = { ...this.props.draft, ...formData };
      this.props.onUpdateDraft(updatedDraft);

      if (this.props.onChange) {
        this.props.onChange(updatedDraft, true);
      }
    }
  };

  get data(): LengthScopeDetails {
    return {
      durationDays: (this.props.draft || {}).durationDays,
      dayType: (this.props.draft || {}).dayType,
    };
  }

  render() {
    return (
      <View className="gs-container">
        <div className="col-sm-8">
          {this.data && (
            <SchemaForm
              className="w-100"
              formData={this.data}
              schema={this.lengthScopeSchema || {}}
              onChange={this.handleChanges}
              externalSubmit
            >
              <div className="d-flex justify-content-center" />
            </SchemaForm>
          )}
        </div>
      </View>
    );
  }
}

const mapStateToProps = (state, ownProps): PropsFromState => {
  return {
    draft: serviceSelectors.getDynamicQuestionDraft(state),
    schema: serviceSelectors.getDynamicQuestionRevisionSchema(state),
    isValid: serviceSelectors.isDynamicQuestionDraftValid(state),
  };
};

const mapDispatchToProps: PropsFromDispatch = {
  onUpdateDraft: actionCreators.UpdateDynamicQuestionDraft,
};

export default compose(localize(), connect(mapStateToProps, mapDispatchToProps))(Step4LengthScope);
